import { Person } from "@/services/DTOs/Person";
import { TrackingService } from "@/services/TrackingService";
import { isTester } from "@/utils/TesterUtil";

export const createLog = (statusCode: number, errorMessage?: string | null, person?: Person | null): boolean => {
  if (statusCode === 500 && process.env.VUE_APP_DISCOVERY_ENVIRONMENT_MODE === "production") {
    if (person) {
      if (!isTester(person)) {
        TrackingService.createErrorLog(statusCode, person, errorMessage ? encodeURIComponent(errorMessage) : "");
        return true;
      }
    } else {
      TrackingService.createErrorLog(statusCode, undefined, errorMessage ? encodeURIComponent(errorMessage) : "");
      return true;
    }
  }
  return false;
};
